/**
 * Created by zjs on 2017/09/05
 * 路由的状态管理
 */

import actions from './actions'
import mutations from './mutations'

const state = {
    globalRouterConfig: [], // 全局路由配置
    currRoute: {}, // 当前路由对象
    currPage: {} // 当前页面对象
}

const getters = {
    globalRouterConfig: state => state.globalRouterConfig,
    currRoute: state => state.currRoute,
    currPage: state => state.currPage
}

export default {
    state,
    getters,
    actions,
    mutations
}